/**
 * Headers for session-authenticated JSON fetch calls: JSON content negotiation
 * plus the Rails CSRF token from the csrf-token meta tag.
 */
export const jsonRequestHeaders = (): Record<string, string> => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-CSRF-Token": (document.querySelector("[name='csrf-token']") as HTMLMetaElement | null)?.content ?? "",
  "X-Requested-With": "XMLHttpRequest",
});
